/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface Availability$Params {
  organisation_id: string;
  domain_name: string;
}

export function availability(
  http: HttpClient,
  rootUrl: string,
  params: Availability$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<{
    [key: string]: any;
  }>
> {
  const rb = new RequestBuilder(rootUrl, availability.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.query("domain_name", params.domain_name, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
        [key: string]: any;
      }>;
    }),
  );
}

availability.PATH = "/surfdomeinen/info/organisations/{organisation_id}/availability";
